import { useToastStore } from './useToast';
import type { ToastType } from './useToast';
import './Toast.css';

const icons: Record<ToastType, string> = {
  success: '✓',
  error: '✕',
  info: 'ℹ',
};

export function ToastContainer() {
  const toasts = useToastStore((s) => s.toasts);

  if (toasts.length === 0) return null;

  return (
    <div className="eb-toast-container" aria-live="polite">
      {toasts.map((t) => (
        <div key={t.id} className={`eb-toast eb-toast--${t.type}`}>
          <span className="eb-toast__icon">{icons[t.type]}</span>
          <span>{t.message}</span>
        </div>
      ))}
    </div>
  );
}
